import { useEffect, useRef, useState } from "react";
import { loginCheck } from "../../api/LoginApi";

export const useLoginStatus = () => {
  const fetchLoginCheckapi = loginCheck();
  const hasRequestedLoginCheck = useRef(false);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(() => {
    const cached = fetchLoginCheckapi.state?.data?.[0]?.isLogin;
    return typeof cached === "boolean" ? cached : null;
  });

  useEffect(() => {
    if (hasRequestedLoginCheck.current) return;
    hasRequestedLoginCheck.current = true;
    if (fetchLoginCheckapi.state?.status === "processing") return;
    fetchLoginCheckapi.fetch();
  }, [fetchLoginCheckapi.state?.status]);
  
  useEffect(() => {
    const status = fetchLoginCheckapi.state?.status;
    const loginFlag = fetchLoginCheckapi.state?.data?.[0]?.isLogin;

    if (typeof loginFlag === "boolean") {
      setIsLoggedIn(loginFlag);
      return;
    }
    if (status === "error") {
      setIsLoggedIn(false);
    }
  }, [fetchLoginCheckapi.state?.status, fetchLoginCheckapi.state?.data]);

  const refresh = () => {
    fetchLoginCheckapi.fetch();
  };

  return { isLoggedIn, refresh };
};
